import * as React from "react";

import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Tree, Classes, Intent } from "@blueprintjs/core";
import { Button, Card, Elevation, Overlay } from "@blueprintjs/core";
import CardTableUsers from "./CardTableUsers.tsx";
//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';
import {
  Alignment,
  H5,
  Icon,
  Navbar,
  Toast,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Toaster,
  Position,
  Code,
  MultistepDialog,
  DialogStep,
  ButtonProps,
  RadioGroup,
  Radio,
  NumericInput,
  Label,
  FormGroup,
  InputGroup
} from "@blueprintjs/core";
import { Checkbox } from "@material-ui/core";
import { IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
const passwordLength = 8;
const numbers = '0123456789';
const upperCaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const lowerCaseLetters = 'abcdefghijklmnopqrstuvwxyz';
const specialCharacters = "!'^+%&/()=?_#$½§{[]}|;:>÷`<.*-@é";
var _obj_allusers=[];
export default class CardAdminClients extends React.Component<{}> {
  state = {
    opencreationsalle: false,
    password: '',
    socketlabtice:null,
    nom: '',
    etablissement: '',
    identifiant: '',
    licence: 0,
    users: {},
    salles: [],
    licences: [],
    licences_used: [],
    postes: [],
    allpostes: [],
    must_refresh: false,
    select_id_userlicence: "",
    select_code_salle: "",
    select_poste: {},
    opendelete: false,
    opendeleteposte: false,
    openaffectelicence: false,
    openchangepassword: false,
    newpassword: '',
    isValideCode: false,
    volume_speakers: '',
    volume_microphone: '',
    time_shutdown: '',
    plugins:'',
    type_classe: '0',
    unc_share: '',
    heurestopped: "",
    minutestopped: "",
    recherche_salle: "",
    recherche_poste: "",
    majall: false,
    showlicences: false,
    isVisibleVersionLabtice: "none",
    labticeversion: { version: "", description: "" },
  }
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    //console.log(this.props); 
    this.getLicences(this.props.userid);
    this.getMatieres();
    this.setState({socketlabtice:this.props.socketlabtice});
    //https://labtice.com/api/public/getmyallusers?id_createur=125
  }
 //1280x1024
  componentDidUpdate(prevProps, prevState) {
    var bchange=false;
    var obju=[];
    if(this.state.socketlabtice!=this.props.socketlabtice)this.setState({socketlabtice:this.props.socketlabtice});
    this.state.licences.filter((it)=>it.id_machine>0).map((it2)=>
    {
      
      _obj_allusers.map((ituser)=>
        {
          if(ituser.ID==it2.id_machine)
          {
            if(ituser.licence=="")
            {
              ituser.licence=it2.type_produit+" "+it2.type_user;
              bchange=true;
            }
          }
          //obju.push(ituser);
        })
    });
    if(bchange)
    {
      //this.setState({ allpostes: [] });
      //setTimeout((ev)=>{this.setState({ allpostes: _obj_allusers });},500);
    }
    if (this.state.must_refresh) {
      this.setState({ must_refresh: false });
      this.getmyusers();
      this.getMatieres();
      this.getLicences(this.props.userid);
    }
  }
  async getlabticeversion() {
    const response = await fetch('/api/public/getlastlabticeversion');
    const llabticeversion = await response.json();
    console.log(llabticeversion);
    this.setState({ labticeversion: llabticeversion });
  }
  async getMatieres() {

    const response = await fetch('/api/public/getmatieres?id_enseignant=' + this.props.userid);
    const salles = await response.json();
    console.log(salles);
    _obj_allusers=[];
    salles.map((it)=>this.getAllUserbycode(it.code,it.matiere));
    /*setTimeout((ev)=>this.setState({ allpostes: _obj_allusers }),500);
    setTimeout((ev)=>this.setState({ allpostes: _obj_allusers }),2000);
    setTimeout((ev)=>this.setState({ allpostes: _obj_allusers }),3000);
    setTimeout((ev)=>this.setState({ allpostes: _obj_allusers }),4000);
    setTimeout((ev)=>this.setState({ allpostes: _obj_allusers }),5000);*/
    //console.log(obj);
    this.setState({ salles: salles });
    
    this.getlabticeversion();
  }
  async setMaj(id, value) {

    var stvalue = "";
    if (value) stvalue = "mettreajour"
    const response = await fetch('/api/public/setmajbyid?id_user=' + id + "&valeur=" + stvalue);
    var obj = [];
    this.state.postes.map((it3) => {
      if (it3.ID == id) it3.maj = stvalue;
      obj.push(it3);
    });
    this.setState({ postes: obj });

  }
  async setMajAll(value) {

    var stvalue = "";
    if (value) stvalue = "mettreajour";
    this.setState({ majall: value });
    var obj = [];
    this.state.postes.map((it3, i) => {
      setTimeout((ev) => this.setMaj(it3.ID, stvalue), i * 50);
    });


  }

  async getvolumes() {
    this.setState({ heurestopped: '' });
    this.setState({ minutestopped: '' });
    this.setState({ type_classe: '0' });
    const response = await fetch('/api/public/getparametrage?code=' + this.state.select_code_salle);
    const params = await response.json();
    console.log(params);
    this.setState({ volume_microphone: params.volume_microphone });
    this.setState({ volume_speakers: params.volume_speaker });
    this.setState({ time_shutdown: params.time_shutdown });
    this.setState({ plugins: params.plugins });
    //this.setState({unc_share:params.unc_share});
    if (params.time_shutdown != "") {
      var hh = params.time_shutdown.split(':')[0];
      var mn = params.time_shutdown.split(':')[1];
      this.setState({ heurestopped: hh });
      this.setState({ minutestopped: mn });
    }
    if (params.type_classe != "") {
      this.setState({ type_classe: params.type_classe });
    }
    else {
      this.setState({ type_classe: '0' });
    }
    if (params.unc_share != "") {
      this.setState({ unc_share: params.unc_share });
    }
    else {
      this.setState({ unc_share: '' });
    }
  }
  async getmyusers() {
    const response = await fetch('/api/public/getmyallusers?id_createur=' + this.props.userid);
    const users = await response.json();
    console.log(users);
    this.setState({ users: users });
  }
  async getUser(id) {
    this.setState({ select_id_userlicence: id })
    const response = await fetch('/api/public/getuser?id=' + id);
    const users = await response.json();
    console.log(users);
    this.setState({ users: users });
  }
  async getUserbycode(code) {
    this.setState({ select_code_salle: code })
    const response = await fetch('/api/public/getusersbycode?code=' + code);
    const postes = await response.json();
    console.log(postes);
    if (postes == null) this.setState({ postes: [] });
    else {
      var objr = [];
      var obj = [];
      postes.map((it) => objr.push(it));
      var obj = [];
      objr.sort((a, b) => {
        if (a.email < b.email) return -1;
        if (a.email > b.email) return 1;
        return 0;
      }).map((itc) => { obj.push(itc); });
      this.setState({ postes: obj });
    }
    await this.getvolumes();

  }
  async getAllUserbycode(code,matiere) {
    //this.setState({ select_code_salle: code })
    const response = await fetch('/api/public/getusersbycode?code=' + code);
    const postesl = await response.json();
    //console.log(postesl);
    //var lobj=[];
    if (postesl != null)  {
      postesl.map((it) => 
      {
        it.matiere=matiere;
        it.code=code;
        it.UpdatedAt=new Date(it.UpdatedAt).toLocaleDateString('fr') + " " + new Date(it.UpdatedAt).toLocaleTimeString('fr');
        _obj_allusers.push(it);
      });
      //this.setState({ allpostes: _obj_allusers });
    }
    var obj=[];
    _obj_allusers.map((itu)=>obj.push(itu));
    //console.log(_obj_allusers)
    obj.map((it)=>{ if(it.maj=="mettreajour")it.majv2="oui"; else it.majv2="non";});
    this.setState({ allpostes: obj });
    
  }
  async getUserbycodeNoChange(code) {
    var salle = this.state.select_code_salle;
    this.setState({ select_code_salle: "" });
    const response = await fetch('/api/public/getusersbycode?code=' + code);
    const postes = await response.json();
    console.log(postes);
    if (postes == null) this.setState({ postes: [] });
    else {
      var objr = [];
      var obj = [];
      postes.map((it) => objr.push(it));
      var obj = [];
      objr.sort((a, b) => {
        if (a.email < b.email) return -1;
        if (a.email > b.email) return 1;
        return 0;
      }).map((itc) => { obj.push(itc); });
      this.setState({ postes: obj });
      this.setState({ postes: postes });
      this.setState({ select_code_salle: salle })
    }
  }

  async getLicences(id_administrateur) {
    //this.setState({select_id:id_administrateur})
    this.setState({ licences: [] });
    const response = await fetch('/api/public/getmyalllicences?id_administrateur=' + id_administrateur);
    const licences = await response.json();
    console.log(licences);
    if(licences!=null)this.setState({ licences: licences });
  }
  async deleteClientPoste(id) {
    
    await this.deleteClientbyname("auto_"+this.state.select_poste.email.toLowerCase())
    this.setState({ select_poste: {} });
    //this.setState({select_code_salle:""});
    const response = await fetch('/api/public/deluserbyid?id_user=' + id);
    var obj = [];
    this.state.postes.map((it) => { if (it.ID != id) obj.push(it) });
    this.setState({ postes: obj });
    //const ret = await response.json();
  }
  async delteMatiere(id) {
    const response = await fetch('/api/public/delmatieres?id_matiere=' + id);
    const resp2 = await this.getMatieres();
  }
  async deleteClient() {
    this.setState({ select_id_userlicence: "" })
    this.setState({ licences: [] });
    if(this.state.select_id_userlicence=="")
    {
      await this.deleteClientbyname("auto_"+this.state.select_poste.email.toLowerCase())
    }
    else
    {
      const response = await fetch('/api/public/deluserbyid?id_user=' + this.state.select_id_userlicence);
      const ret = response.text;
    }
    setTimeout((ev) => this.getLicences(this.props.userid), 2000);
  }
  async deleteClientbyname(stname) {
    this.setState({ select_id_userlicence: "" })
    this.setState({ licences: [] });
    const response = await fetch('/api/public/deluserbyname?name=' + stname);
    const ret = response.text;
    setTimeout((ev) => this.getLicences(this.props.userid), 2000);
  }
  
  handleGeneratePassword = () => {
    let characterList = "";
    characterList = characterList + numbers
    characterList = characterList + upperCaseLetters
    characterList = characterList + lowerCaseLetters
    /*if (includeSymbols) {
      characterList = characterList + specialCharacters
    }*/
    this.setState({ password: this.createPassword(characterList) })

  }
  createPassword = (characterList) => {
    let password = ""
    const characterListLength = characterList.length
    for (let i = 0; i < passwordLength; i++) {
      const characterIndex = Math.round(Math.random() * characterListLength)
      password = password + characterList.charAt(characterIndex)
    }
    return password
  }
  handleChangeNom = (ev) => {
    var valeur = ev.target.value;
    this.setState({ nom: valeur });
  }
  handleChangeEtablissement = (ev) => {
    var valeur = ev.target.value;
    this.setState({ etablissement: valeur });
  }
  handleChangeIdentifiant = (ev) => {
    var valeur = ev.target.value;
    this.setState({ identifiant: valeur });
  }
  handleChangeLicence = (ev) => {
    var valeur = ev.target.value;
    this.setState({ licence: valeur });
  }
  handleSendCode = function (matiere, userid, description) {

    this.setState({ isValideCode: false });
    var that = this;
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");
    var formData = new FormData();
    formData.append('matiere', matiere);
    formData.append('id_enseignant', userid);
    formData.append('description', description);

    xhr.open('POST', '/api/public/creatematiere')

    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send(JSON.stringify(Object.fromEntries(formData)));

    xhr.onreadystatechange = function () {
      if (xhr.readyState == XMLHttpRequest.DONE) {

        if (xhr.status == 200) {
          that.setState({ isValideCode: true });
          console.log(xhr.responseText);
          var jsonResponse = JSON.parse(xhr.responseText);
          console.log(jsonResponse);
          var obj = [];
          that.state.salles.map((it) => obj.push(it));
          var ret = jsonResponse;
          that.getMatieres();
        }
        if (xhr.status == 404) { that.setState({ isValideCode: true }); return; }
        if (xhr.status == 500) { that.setState({ isValideCode: true }); return; }

        that.setState({ isValideCode: false });
      }
    }
    return //setisOpenLogin(false)
  }
  async updateSalle(code, id) {
    const response = await fetch('/api/public/updatecode?code=' + code + "&id_user=" + id);
    const postes = await response.json();
    await this.getUserbycodeNoChange(this.state.select_code_salle);
  }
  async handleChangeSalle(e, id,postes,salles){
    //ev.preventDefault()
    var code = e.target.value;
    //this.updateSalle(code, id);
    const response =  await fetch('/api/public/updatecode?code=' + code + "&id_user=" + id);
    //const postes = await response.json();
    var obj = [];
    postes.map((it3) => {
      if(response.status==200)
      {
        if (it3.ID == id) 
        {
          it3.code = code;
        
          it3.matiere=salles.filter((itt)=>itt.code==code)[0]
        }
      }
      obj.push(it3);
    });
    return obj;

    // https://labtice.com/api/public/updatecode?id_user=148&code=374495
  }
  handleSendCreateEnseignant = (nickname, name, email, password, licence, matiere, etablissement) => {
    email = "auto_" + email;
    name = email;
    nickname = email;
    password = "auto";
    this.props.handleSendCreateEnseignant(nickname, name, email, password, licence, matiere, etablissement);
    setTimeout((ev) => this.setState({ must_refresh: true }), 2000);
  }
  handleChangeVolumeSpeakers = (vol_speakers) => {
    this.setState({ volume_speakers: vol_speakers });
  }
  handleChangeVolumeMicrophone = (vol_microphone) => {
    this.setState({ volume_microphone: vol_microphone });
  }
  handleChangeHeure = (heure) => {
    //if(heure!="")
    this.setState({ heurestopped: heure });
    //if(minutes!="")
    //this.setState({minutestopped:minutes});
    setTimeout((ev) => this.setState({ time_shutdown: this.state.heurestopped + ":" + this.state.minutestopped }), 1000);
  }
  handleChangeMinutes = (minutes) => {
    //if(heure!="")
    //this.setState({heurestopped:heure});
    //if(minutes!="")
    this.setState({ minutestopped: minutes });
    setTimeout((ev) => this.setState({ time_shutdown: this.state.heurestopped + ":" + this.state.minutestopped }), 1000);
  }
  handleTypeClasse = (valeur) => {
    this.setState({ type_classe: valeur });
  }
  handleChangeCheminSeances = (valeur) => {
    this.setState({ unc_share: valeur });
  }
  handleChangePlugIns= (valeur) => {
    this.setState({ plugins: valeur });
  }
  async changepassword(id, password) {
    const response = await fetch("api/public/setchangepasswordbyid?id_user=" + id + "&valeur=" + password);
    const ret = await response.text;
  }
  async getDoublonsMac() {
    const response = await fetch('/api/public/getdoublons');
    const doublon = await response.json();
    console.log(doublon);
  }

  refresh_users=(data)=>
  {
    if(data==null)
    {
      this.setState({must_refresh:true});
      setTimeout((ev)=>{
        this.getDoublonsMac();
      },5000)
      return;
    }
    _obj_allusers=data;
    this.setState({ allpostes: data });
  }

  setAutoLogin=(id,value)=>{
    if(value)this.state.allpostes.map((it3)=>{if(it3.ID==id){this.setState({ select_poste: it3 }); this.setState({ select_id_userlicence: "" }); this.setState({ openaffectelicence: true })}})
    else 
    {
      this.state.allpostes.map((it3)=>{if(it3.ID==id){this.setState({ select_poste: it3 }); this.setState({ select_id_userlicence: "" }); }})
      this.setState({ opendelete: true }) 
    }
  }
  setAutoDelete=(id)=>{
      this.state.allpostes.map((it3)=>{if(it3.ID==id){this.setState({ select_poste: it3 }); this.setState({ select_id_userlicence: "" }); }})
      this.setState({ opendeleteposte: true }) 
  }
  sendParametrageVolume = () => {
    //Send this.state.volume_microphone et this.state.volume_speakers
    var that = this;
    var xhr = new XMLHttpRequest();
    xhr.overrideMimeType("application/json");
    var formData = new FormData();
    formData.append('code', this.state.select_code_salle);
    formData.append('volume_speaker', this.state.volume_speakers);
    formData.append('volume_microphone', this.state.volume_microphone);
    formData.append('time_shutdown', this.state.time_shutdown);
    formData.append('type_classe', this.state.type_classe);
    formData.append('unc_share', this.state.unc_share);
    formData.append('plugins', this.state.plugins);

    xhr.open('POST', '/api/public/setparametrage')

    xhr.setRequestHeader("Content-Type", "application/json");

    //send the form data
    xhr.send(JSON.stringify(Object.fromEntries(formData)));

    xhr.onreadystatechange = function () {
      if (xhr.readyState == XMLHttpRequest.DONE) {

        if (xhr.status == 200) {
          console.log(xhr.responseText);
        }
        if (xhr.status == 404) { return; }
        if (xhr.status == 500) { return; }
      }
    }
    return
  }

  render() {
   return (
      <div>
        <Card>
          <Card>
          {this.state.labticeversion.version!=""?<CardTableUsers handleChangeSalle={this.handleChangeSalle} salles={this.state.salles} labticeversion={this.state.labticeversion} socketlabtice={this.state.socketlabtice} setAutoLogin={this.setAutoLogin} setAutoDelete={this.setAutoDelete} refresh={this.refresh_users} dataclientdetails={this.state.allpostes}></CardTableUsers>:null}
            <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}>
              <IconButton onClick={() => { if (this.state.isVisibleVersionLabtice == 'none') this.setState({ isVisibleVersionLabtice: 'block' }); else this.setState({ isVisibleVersionLabtice: 'none' }); }}>
                {this.state.isVisibleVersionLabtice == 'none' ? <VisibilityIcon /> : <VisibilityOffIcon />}
              </IconButton>
              <H5 onClick={() => { if (this.state.isVisibleVersionLabtice == 'none') this.setState({ isVisibleVersionLabtice: 'block' }); else this.setState({ isVisibleVersionLabtice: 'none' }); }} style={{ cursor: "pointer", margin: '8px 0px' }}>Dernière Version Labtice</H5>
              <Button onClick={(ev) => this.setState({ openchangepassword: true })} style={{ padding: 10, margin: 4 }}>Modifier mon mot de passe</Button>
              <Card style={{ display: this.state.isVisibleVersionLabtice }}>
                <p>Date : {new Date(this.state.labticeversion.UpdatedAt).toLocaleDateString('fr') + " " + new Date(this.state.labticeversion.UpdatedAt).toLocaleTimeString('fr')}</p>
                <p>Numéro de version : {this.state.labticeversion.version}</p>
                <p>Description de la version : {this.state.labticeversion.description}</p>
              </Card>
            </div>
          </Card>
          <Card>
            <H5>Vos licences tuteurs</H5>
            <Card>
              <Button style={{ margin: 5, backgroundColor: "#444", color: "#fff" }} onClick={(ev) => { this.setState({ showlicences: !this.state.showlicences }); }} icon={this.state.showlicences ? "eye-open" : "eye-off"} />
              {this.state.licences.filter((itf) => itf.type_user == "teacher").map((it2, i) =>
                this.state.showlicences ?
                  <div style={{ padding: 10, margin: 4, backgroundColor: it2.id_user == 0 ? '#b5d7c9' : '#fcc', borderRadius: 4 }}>
                    <Button style={{ margin: 5, backgroundColor: "#444", color: "#fff" }} onClick={(ev) => { if (this.state.select_id_userlicence == it2.id_user) { this.setState({ select_id_userlicence: "" }); } else this.getUser(it2.id_user) }} icon={it2.id_user == this.state.select_id_userlicence ? "minus" : "plus"} />
                    <span><Icon style={{ marginRight: 10 }} icon="application"></Icon>Licence <b>Labtice {it2.type_produit}</b> n°{(i + 1) + " : "}<b>{it2.licence}</b></span><div style={{ marginLeft: 40 }}><Icon style={{ marginRight: 10 }} icon="calendar"></Icon>créé le: {new Date(it2.CreatedAt).toLocaleDateString('fr')}<span style={{ marginLeft: 15 }}>valide jusqu'au {new Date(parseInt(it2.end_date)).toLocaleDateString()}</span></div>
                    {it2.id_user == 0 ? <div><Button style={{ marginLeft: 40, marginTop: 5 }} onClick={(ev) => { window.location.href = "mailto:?subject=Votre licence enseignant Labtice&body=" + it2.licence }} icon="send-message">Envoyer par mail</Button></div> : null}
                    {this.state.select_id_userlicence == it2.id_user ? it2.id_user > 0 ? <div style={{ margin: 10, padding: 12, borderRadius: 4, color: '#fff', backgroundColor: '#db5454' }}>{this.state.users.email}<Button style={{ marginLeft: 10, backgroundColor: "#444", color: "#fff" }} onClick={(ev) => { this.setState({ opendelete: true }) }} icon="trash"></Button></div> : null : null}
                  </div> : null)}
            </Card>
          </Card>
          <Card>
            <H5>Vos postes</H5>
            <Button style={{ margin: 10 }} onClick={(ev) => this.setState({ opencreationsalle: true })}>Créer une salle ou un chariot</Button>
            {this.state.opencreationsalle ?
              <Card>
                <FormGroup helperText=""
                  label="Nom de la salle ou du chariot mobile"
                  labelFor="id_nom"
                  labelInfo="*">
                  <InputGroup onChange={(ev) => this.handleChangeNom(ev)} id="id_nom" value={this.state.nom} placeholder="Nom de la salle ou du chariot" />
                </FormGroup>
                <Button onClick={(ev) => { this.handleSendCode(this.state.nom, this.props.userid, ""); this.setState({ opencreationsalle: !this.state.opencreationsalle }); setTimeout((ev) => this.setState({ must_refresh: true }), 3000); }} disabled={this.state.nom == ""} icon="send-message">Créer la salle</Button>
              </Card> : null}
            <Card>
              <div style={{ borderRadius: 6, backgroundColor: '#c0e9ce', padding: '10px 10px 5px', margin: '10px 0' }}>Rechercher une salle : <input value={this.state.recherche_salle} style={{ marginLeft: 10 }} onChange={(ev) => this.setState({ recherche_salle: ev.target.value })} type="text" /></div>
              {this.state.salles.map((it2, i) =>
                it2.matiere.toLowerCase().includes(this.state.recherche_salle.toLowerCase()) ?
                  <div style={{ padding: 10, margin: 4, backgroundColor: '#8cd5f1', borderRadius: 4 }}>
                    <Button style={{ margin: 5, backgroundColor: "#444", color: "#fff" }} onClick={(ev) => { if (this.state.select_code_salle == it2.code) { this.setState({ select_code_salle: "" }); this.setState({ postes: [] }); } else { this.getUserbycode(it2.code); } }} icon={it2.code == this.state.select_code_salle ? "minus" : "plus"} />
                    {this.state.select_code_salle == it2.code ? <Button style={{ backgroundColor: "#444", color: "#fff", marginLeft: 25 }} onClick={(ev) => this.delteMatiere(it2.ID)} disabled={this.state.postes.length > 0} icon="trash"></Button> : null}
                    <span style={{ marginLeft: 25 }}>Nom: <b>{it2.matiere}</b></span><span style={{ marginLeft: 30 }}>Code pour la salle: <b>{it2.code}</b></span>
                    {this.state.select_code_salle == it2.code ? <div style={{ padding: 10, borderRadius: 6, backgroundColor: '#6aaed7' }}>
                      <div style={{ padding: 4 }}><span style={{ marginRight: 4 }}>Type de classe</span><select onChange={(ev) => this.handleTypeClasse(ev.target.value,)} style={{ padding: 6, borderRadius: 6, marginLeft: 6 }}><option selected={this.state.type_classe == "0"} value="0">Défaut type chariot</option><option selected={this.state.type_classe == "1"} value="1">auto sélection type salle physique</option><option selected={this.state.type_classe == "2"} value="2">administration classe non visible</option></select></div>
                      <div style={{ padding: 4 }}><span style={{ marginRight: 25 }}>Volume speakers</span><input onChange={(ev) => this.handleChangeVolumeSpeakers(ev.target.value)} value={this.state.volume_speakers} type="text"></input></div>
                      <div style={{ padding: 4 }}><span style={{ marginRight: 4 }}>Volume microphone</span><input onChange={(ev) => this.handleChangeVolumeMicrophone(ev.target.value)} value={this.state.volume_microphone} type="text"></input></div>
                      <div style={{ padding: 4 }}><span style={{ marginRight: 4 }}>Heure et minutes de l'arrêt des postes</span><input style={{ width: 40 }} onChange={(ev) => this.handleChangeHeure(ev.target.value)} value={this.state.heurestopped} type="number"></input>:<input style={{ width: 40 }} onChange={(ev) => this.handleChangeMinutes(ev.target.value,)} value={this.state.minutestopped} type="number"></input></div>
                      <div style={{ padding: 4 }}><span style={{ marginRight: 4 }}>Chemin pour les séances</span><input style={{ width: 400 }} onChange={(ev) => this.handleChangeCheminSeances(ev.target.value)} value={this.state.unc_share} ></input></div>
                      <div style={{ padding: 4 }}><span style={{ marginRight: 4 }}>Plug-Ins</span><input style={{ width: 400 }} onChange={(ev) => this.handleChangePlugIns(ev.target.value)} value={this.state.plugins} ></input></div>
                      {/*<Button disabled={((this.state.volume_microphone=="" || this.state.volume_speakers=="") || this.state.time_shutdown=="" || this.state.unc_share=="")} onClick={(ev)=>this.sendParametrageVolume()}>Envoyer le paramétrage</Button></div>:null}*/}
                      <Button onClick={(ev) => this.sendParametrageVolume()}>Envoyer le paramétrage</Button></div> : null}
                    {this.state.select_code_salle == it2.code ?
                      <div style={{ marginTop: 4, padding: 10, borderRadius: 6, backgroundColor: '#6aaed7' }}>
                        <Button style={{ backgroundColor: "#444", color: "#fff" }} onClick={(ev) => this.setMajAll(!this.state.majall)} icon="updated">Tous les postes</Button>
                      </div> : null}
                    {this.state.select_code_salle == it2.code ?
                      <div style={{ borderRadius: 6, backgroundColor: '#c0e9ce', padding: '10px 10px 5px', margin: '10px 0' }}>Rechercher un poste : <input value={this.state.recherche_poste} style={{ marginLeft: 10 }} onChange={(ev) => this.setState({ recherche_poste: ev.target.value })} type="text" /></div>
                      : null}
                    {this.state.select_code_salle == it2.code ? this.state.postes.map((it3, i) =>
                      it3.email.toLowerCase().includes(this.state.recherche_poste.toLowerCase()) ?
                        <div style={{ padding: 10, margin: 4, backgroundColor: '#bae7f9', borderRadius: 4 }}>
                          <span style={{ width: 350, display: 'inline-block' }}>Nom machine: {it3.email}</span><span style={{ marginLeft: 25 }}>Dernière cnx: {new Date(it3.UpdatedAt).toLocaleDateString('fr') + " " + new Date(it3.UpdatedAt).toLocaleTimeString('fr')}</span><span style={{ marginLeft: 25 }}>IP: {it3.iplocal}</span><span style={{ width: 125, display: 'inline-block', marginLeft: 25, fontWeight: this.state.labticeversion.version != it3.version ? "800" : "400" }}>Version: {it3.version != "" ? it3.version : "0.0.0.000"}</span><span style={{ marginLeft: 10 }}><Checkbox onChange={(ev) => { this.setMaj(it3.ID, ev.target.checked) }} checked={it3.maj != "mettreajour" ? false : true}></Checkbox>Mettre à jour</span>
                          <select style={{ padding: 6, borderRadius: 6, marginLeft: 20 }} onChange={(ev) => this.handleChangeSalle(ev, it3.ID)} >{this.state.salles.map((it4, i) => { if (it4.code != it2.code) { return (<option value={it4.code}>{it4.matiere}</option>) } else { return (<option selected value={it4.code}>{it4.matiere}</option>) } })}</select>
                          <Button style={{ marginLeft: 10, backgroundColor: "#444", color: "#fff" }} onClick={(ev) => { this.setState({ select_poste: it3 }); this.setState({ select_id_userlicence: "" }); this.setState({ openaffectelicence: true }) }} icon="tag">Auto login</Button>
                          <Button style={{ marginLeft: 10, backgroundColor: "#444", color: "#fff" }} onClick={(ev) => { this.setState({ select_poste: it3 }); this.setState({ opendeleteposte: true }) }} icon="trash"></Button>
                        </div> : null
                    ) : null}
                  </div> : null

              )}

            </Card>
          </Card>
          <Card>
            <H5>INSTALLEZ LABTICE SUR WINDOWS</H5>
            <Card>
              <Button style={{ backgroundColor: "#444", color: "#fff" }} onClick={(ev) => window.open("data/setup/SetupLabtice.msi", "_blank")} icon="download">Téléchargez Labtice</Button>
              <p></p>
              <H5>INSTALLATION</H5>
              <p>1- Au démarrage de Labtice, saisir le code de la salle que vous avez créé.</p>
              <p>ou lancer la commande <b>reg add \\NOM_ORDINATEUR\HKLM\Software\Labtice /v code_salle /t REG_SZ /f /d CODE_DE_VOTRE_SALLE</b></p>
              <p>ou écrire la clé <b>HKLM\Software\Labtice  code_salle  de type REG_SZ et de valeur CODE_DE_VOTRE_SALLE dans la base de registre des ordinateurs</b>.</p>
            </Card>
          </Card>
          <Card>
            <Card>
              <H5>ASTUCE LABTICE POUR LES ADMINISTRATEURS</H5>
              <p>Si vous utilisez la fonction diffusez un document et que vous choisissez un fichier avec une extension .msi,<br /> alors une fois transféré, le fichier msi s'éxécutera avec les paramètres /quiet et /passive vous évitant de faire x clics sur chaque poste.</p>
            </Card>
          </Card>
        </Card>

        <Overlay isOpen={this.state.opendelete} className={Classes.OVERLAY_SCROLL_CONTAINER} >
          <div style={{ color: '#444', background: '#fff', padding: '30px', width: '90%', margin: '30px 5%' }}>

            <H5>ATTENTION vous allez effacer la licence pour cet enseignant: </H5>
            {this.state.users.email!=""?<div><b>{this.state.users.email}</b><div><H5>L'enseignant {this.state.users.email} n'aura plus accès à LABTICE</H5></div></div>
                                       :<div><b>{this.state.select_poste.email}</b><div><H5>L'enseignant {this.state.select_poste.email} n'aura plus accès à LABTICE</H5></div></div>}
            <Button intent={Intent.WARNING} onClick={(ev) => { ev.preventDefault(); this.deleteClient(); this.setState({ opendelete: false }); }} style={{ margin: 4 }}>
              Je veux effacer cet enseignant
            </Button>
            <Button intent={Intent.DANGER} onClick={(ev) => { ev.preventDefault(); this.setState({ opendelete: false }) }} style={{ margin: 4 }}>
              Annuler
            </Button>
          </div>
        </Overlay>
        <Overlay isOpen={this.state.opendeleteposte} className={Classes.OVERLAY_SCROLL_CONTAINER} >
          <div style={{ color: '#444', background: '#fff', padding: '30px', width: '90%', margin: '30px 5%' }}>

            <H5>ATTENTION vous allez effacer le code pour cette machine: {this.state.select_poste.email}</H5>
            <div><H5>Au redémarrage de ce poste, un nouveau code sera demandé</H5></div>
            <Button intent={Intent.WARNING} onClick={(ev) => { ev.preventDefault(); this.deleteClientPoste(this.state.select_poste.ID); this.setState({ opendeleteposte: false }); }} style={{ margin: 4 }}>
              Je veux effacer ce code sur cette machine
            </Button>
            <Button intent={Intent.DANGER} onClick={(ev) => { ev.preventDefault(); this.setState({ opendeleteposte: false }) }} style={{ margin: 4 }}>
              Annuler
            </Button>
          </div>
        </Overlay>
        <Overlay isOpen={this.state.openchangepassword} className={Classes.OVERLAY_SCROLL_CONTAINER} >
          <div style={{ color: '#444', background: '#fff', padding: '30px', width: '90%', margin: '30px 5%' }}>

            <H5>MODIFIER VOTRE MOT DE PASSE</H5>

            <FormGroup helperText=""
              label="Mot de passe SANS CARACTERE SPECIAL"
              labelFor="id_motdepasse"
              labelInfo="*">
              <InputGroup onChange={(ev) => this.setState({ newpassword: ev.target.value })} id="id_motdepasse" value={this.state.newpassword} placeholder="Nouveau mot de passe" />
            </FormGroup>
            <Button intent={Intent.WARNING} onClick={(ev) => { ev.preventDefault(); this.changepassword(this.props.userid, this.state.newpassword); this.setState({ openchangepassword: false }); }} style={{ margin: 4 }}>
              Modifier
            </Button>
            <Button intent={Intent.DANGER} onClick={(ev) => { ev.preventDefault(); this.setState({ openchangepassword: false }) }} style={{ margin: 4 }}>
              Annuler
            </Button>
          </div>
        </Overlay>
        <Overlay isOpen={this.state.openaffectelicence} className={Classes.OVERLAY_SCROLL_CONTAINER} >
          <div style={{ color: '#444', background: '#fff', padding: '30px', width: '90%', margin: '30px 5%' }}>

            <H5>Affecter une licence Enseignante de libre à cette machine: {this.state.select_poste.email}</H5>
            <div><p>Affecter une licence à un poste professeur, permet à n'importe quel enseignant de se connecter sans login ou mot de passe</p></div>
            <Card>
              {this.state.licences.filter((itf) => itf.type_user == "teacher").map((it2, i) => {
                if (it2.id_user == 0) return (
                  <div style={{ padding: 10, margin: 4, backgroundColor: this.state.select_id_userlicence == it2.licence ? '#33b4e5' : '#b5d7c9', borderRadius: 4 }}>
                    <span><Icon style={{ marginRight: 10 }} icon="application"></Icon>Licence <b>Labtice {it2.type_produit}</b> {(i + 1) + " : "}<b>{it2.licence}</b></span><div><Icon style={{ marginRight: 10 }} icon="calendar"></Icon>créé le: {new Date(it2.CreatedAt).toLocaleDateString('fr')}<span style={{ marginLeft: 15 }}>valide jusqu'au {new Date(parseInt(it2.end_date)).toLocaleDateString()}</span></div>
                    <div><Button onClick={(ev) => { this.setState({ select_id_userlicence: it2.licence }) }} >choix de cette licence</Button></div>
                  </div>)
              })}<H5>{this.state.select_id_userlicence}</H5>
            </Card>
            <Button intent={Intent.WARNING} disabled={this.state.select_id_userlicence == ""} onClick={(ev) => { ev.preventDefault(); this.setState({ openaffectelicence: false }); this.handleSendCreateEnseignant(this.state.select_poste.email, this.state.select_poste.email, this.state.select_poste.email, this.state.select_poste.email, this.state.select_id_userlicence, "", ""); }} style={{ margin: 4 }}>
              Je veux affecter une licence à cette machine
            </Button>
            <Button intent={Intent.DANGER} onClick={(ev) => { ev.preventDefault(); this.setState({ openaffectelicence: false }) }} style={{ margin: 4 }}>
              Annuler
            </Button>
          </div>
        </Overlay>
      </div>);
  }
}
